export default "__VITE_ASSET__BdSqWWoF__"